/* @bend-expect quartz-no-create-browser-history */

import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
import { getMarketplaceEventProps } from 'marketplace-ui-tracking';
import { createContainer } from 'usage-tracker-multi';
import { withSessionReplay } from 'usage-tracker-session-replay';
function getSessionUrlParams() {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
}
let trackContainer;
let tracker;
export function createStandaloneTracker({
  appContext,
  history,
  referrer
}) {
  if (!trackContainer) {
    trackContainer = createContainer({
      history
    });
  }
  if (!tracker) {
    const baseTracker = trackContainer.createTracker({
      standalone: true,
      trackerType: appContext === 'app' ? 'authed' : 'public',
      properties: getMarketplaceEventProps({
        inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
        referrer,
        sessionUrlParams: getSessionUrlParams()
      }),
      lastKnownEventProperties: ['screen']
    });
    // Session replay's endpoint only exists on app.hubspot.com — calling it
    // from the public storefront 404s and triggers a retry storm, and replay
    // isn't useful for anonymous users anyway.
    tracker = appContext === 'app' ? withSessionReplay(baseTracker) : baseTracker;
  }
  return tracker;
}

/**
 * ListingCard Search Result Event Props
 */

export function getSourceIdByCard(card) {
  return card.products.map(({
    sourceId,
    productType
  }) => `${String(productType)}__${sourceId}`);
}
export function getInstalledByCard(card) {
  var _card$products$;
  return Boolean((_card$products$ = card.products[0]) === null || _card$products$ === void 0 ? void 0 : _card$products$.installed);
}

// TODO: add typeguard
export function getProductTypeByCard(card) {
  return card.products.length ? card.products[0].productType : undefined;
}

/**
 * AutocompleteResultItem Search Result Event Props
 */

// TODO: add typeguard
export function getProductTypeByAutocompleteResultItem(item) {
  var _item$products$;
  return item.products.length ? (_item$products$ = item.products[0]) === null || _item$products$ === void 0 ? void 0 : _item$products$.productType : undefined;
}
export function getSourceIdByAutocompleteResultItem(item) {
  return item.products.map(product => `${String(product.productType)}__${product.sourceId}`);
}
export function getRecommendationTypeByCard(card) {
  const mappedRecommendationSources = card.recommendationSources.map(source => `${source.sourceName}__${source.version}`);
  const mappedHighlights = card.highlights.map(h => h.sectionType ? `highlight__${String(h.source.type)}__${String(h.sectionType)}` : `highlight__${String(h.source.type)}`);
  return [...mappedRecommendationSources, ...mappedHighlights];
}